<template>
	<div class="avatar" :class="classes">
		<img v-placeholder-image class="object-cover">
	</div>
</template>

<script>
	export default {
		props: {
			imageClass: {
				type: String,
				default: 'bg-white'
			},
			size: {
				type: String,
				default: 'md'
			},
			rounded: {
				type: String,
				default: 'circle'
			},
			border: {
				type: Boolean,
				default: false
			}
		},
		setup(props) {
			const classes = [
				`avatar-${props.size}`,
				`rounded-${props.rounded}`,
				props.imageClass,
				(props.border) ? 'border' : null
			];

			return { classes };
		}
	}
</script>